import React from 'react';
import { Box, Button, Container, Typography, alpha, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';

const STEPS = [
  { key: 'step1', emoji: '👤' },
  { key: 'step2', emoji: '🔍' },
  { key: 'step3', emoji: '💳 💵' },
  { key: 'step4', emoji: '✅' },
];

const HomeHowItWorksSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isAuthenticated } = useAuth();

  return (
    <Box component="section" sx={{ py: { xs: 4, md: 5 }, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
            {t('homepage.howItWorks.title')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
            gap: 2.5,
          }}
        >
          {STEPS.map((step, index) => (
            <Box key={step.key} sx={{ textAlign: 'center', position: 'relative', height: '100%' }}>
                {index < STEPS.length - 1 && (
                  <Box
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      position: 'absolute',
                      top: 28,
                      left: '50%',
                      width: '100%',
                      height: 5,
                      background: `${theme.palette.primary.main}`,
                      zIndex: 0,
                    }}
                  />
                )}

                <Box sx={{ position: 'relative', zIndex: 1 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      mx: 'auto',
                      mb: 2,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: step.key === 'step3' ? '1rem' : '1.5rem',
                      background: '#fff',
                      border: `4px solid ${theme.palette.primary.main}`,
                      boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.15)}`,
                      flexShrink: 0,
                    }}
                  >
                    {step.emoji}
                  </Box>

                  <Typography variant="h6" component="h3" sx={{ fontWeight: 700, mb: 1 }}>
                    {t(`homepage.howItWorks.steps.${step.key}.title`)}
                  </Typography>
                  <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {t(`homepage.howItWorks.steps.${step.key}.description`)}
                  </Typography>
                </Box>
            </Box>
          ))}
        </Box>

        <Box sx={{ textAlign: 'center', mt: { xs: 3, md: 4 } }}>
          <Button
            component={RouterLink}
            to={isAuthenticated ? '/search' : '/login'}
            variant="contained"
            size="large"
            sx={{
              px: 4,
              py: 1.25,
              borderRadius: 3,
              fontWeight: 700,
              textTransform: 'none',
            }}
          >
            {t('homepage.howItWorks.cta')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HomeHowItWorksSection;